import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";

export const StyledToastButton = styled(Button)`
    & > div {
        color: ${colorsPalettes.carbon[0]} !important;
    }
`;
